import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Upsarpanch from './pages/Upsarpanch';
import Sarpanch from './pages/Sarpanch';
import SabhechiMahiti from './pages/SabhechiMahiti';
import MrutDakhala from './pages/MrutDakhala';
import JanmDakhala from './pages/JanmDakhala';
import VivahDakhala from './pages/VivahDakhala';
import GramsevakPage from './pages/GramsevakPage';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import GPTeam from './pages/GPTeam';
import VikasKame from './pages/VikasKame';
import GramPanchayatNamuna8 from './pages/GramPanchayatNamuna8';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/sarpanch" element={<Sarpanch />} />
          <Route path="/upsarpanch" element={<Upsarpanch />} />
          <Route path="/sachiv" element={<GramsevakPage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/meeting" element={<SabhechiMahiti />} />
          <Route path="/mrut-dakhala" element={<MrutDakhala />} />
          <Route path="/janm-dakhala" element={<JanmDakhala />} />
          <Route path="/vivah-dakhala" element={<VivahDakhala />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/team" element={<GPTeam />} />
           <Route path="/devlopment" element={<VikasKame />} />
           <Route path="/namuna" element={<GramPanchayatNamuna8/>} />
         


        </Routes>
      </Layout>
    </Router>
  );
}

export default App;